<template>
<modal class="is-tall" :overlay-closes="false" title="Checkpoint search">
  <div class="mb-2">
    <div class="columns">
      <div class="column">
        <p>
          Search the backend for checkpoints that are not already associated with this Standard. 
          Please note that checkpoints may only appear once on any given standard.
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <form>
          <text-input 
            v-model="search" 
            placeholder="search for an existing checkpoint">
            Checkpoint
            <template #right>
              <submit-button
                @submit="runSearch"
                :working="searching">
                <icon icon="search"/>
                <span>Search</span>
              </submit-button>
            </template>
          </text-input>
        </form>

        <div v-if="checkpoints.length">
          <div class="columns">
            <div class="column">
              <p class="is-size-5 mt-1 has-text-weight-bold">
                Checkpoints available ({{ checkpointsAvailable.length }})
              </p>
            </div>
          </div>

          <div class="columns border-bottom pointer" v-for="checkpoint in checkpoints" :key="checkpoint.id">
            <div class="column">
              <div class=" is-flex justify-between">
                <div>
                  <p>{{ checkpoint.value }}</p>
                  <p>appears on {{ checkpoint.sections_count }} other standards</p>
                  <text-input placeholder="15|int">Secure Setting</text-input>
                </div>
                <action-button 
                  @click="toggle(checkpoint)" 
                  class="is-small is-rounded"
                  :class="{
                    'is-info': isSelected(checkpoint)
                  }">
                  <icon :icon="isSelected(checkpoint) ? 'times' : 'plus'"/>
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <template #footer>
    <action-button @click="storeCheckpoints" :disabled="!selected_checkpoints.length" class="is-fullwidth">Add {{ selected_checkpoints.length }} checkpoints</action-button>
  </template>
</modal>
</template>
<script>
import { addCheckpoints } from '@/api/super'
import { getPath } from '@/api/common'
import { difference } from 'lodash'

export default {

  props: {
    section: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    searching: false,
    search: '',
    checkpoints: [],
    selected_checkpoints: []
  }),

  methods: {
    runSearch() {
      this.searching = true
      getPath({
        path: `/api/super/section/${this.section.id}/checkpoints-available`,
        params: {
          search: this.search
        }
      }, ({data}) => {
        this.checkpoints = data
        this.searching = false
      }, error => {
        this.searching = false
      })
    },
    toggle(checkpoint) {
      if(this.isSelected(checkpoint)) {
        let index = this.selected_checkpoints.indexOf(checkpoint)
        this.selected_checkpoints.splice(index, 1)
      } else {
        this.selected_checkpoints.push(checkpoint)
      }
      
    },
    isSelected(checkpoint) {
      let index = this.selected_checkpoints.indexOf(checkpoint)

      return index > -1
    },
    storeCheckpoints() {
      addCheckpoints({
        sectionId: this.section.id,
        checkpoints: this.selected_checkpoints.map(check => check.id)
      }, () => {
        this.$toast.success('Checkpoints Added')
        this.$close(true)
      }, error => {
        this.$toast.error('try again')
      })
    }
  },

  computed: {
    checkpointsAvailable() {
      return difference(
        this.checkpoints,
        this.selected_checkpoints
      )
    }
  }

}
</script>
